import { render, staticRenderFns } from "./ContentComp.vue?vue&type=template&id=5c42ca6c&scoped=true"
import script from "./ContentComp.vue?vue&type=script&lang=js"
export * from "./ContentComp.vue?vue&type=script&lang=js"
import style0 from "./ContentComp.vue?vue&type=style&index=0&id=5c42ca6c&prod&lang=less&scoped=true"
import style1 from "./ContentComp.vue?vue&type=style&index=1&id=5c42ca6c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c42ca6c",
  null
  
)

export default component.exports